import * as React from 'react';
import { useState, useRef, useEffect } from 'react';

export interface PollResultProps {
  label: string;
  id: string;
  checked: boolean;
  pollResults: any;
}

export const PollResult = (props : PollResultProps) => {

  const [pollScore, setPollScore] = useState(0);
  const pollScoreBackgroundElement = useRef(null);

  useEffect(() => {
    if (!props.pollResults || !props.pollResults.Results || !props.label || !props.pollResults.TotalCount) {
      return;
    }

    const resultForOption = props.pollResults.Results[(props.label || "").trim()];
    if (!resultForOption) {
      return;
    }
    
    const totalCount = props.pollResults.TotalCount;
    if (totalCount > 0) {
      const percentage =  Math.round(resultForOption * 100 / totalCount);
      setPollScore(percentage);
    }
  }, [props.label, props.id, props.pollResults]);

  useEffect(() => {
    if (pollScore > 0 && pollScoreBackgroundElement.current) {
      setTimeout(() => {
        (pollScoreBackgroundElement.current as HTMLElement).style.width = pollScore + "%";
      }, 10);
    }
  }, [pollScore]);

  if (!props.pollResults || !props.pollResults.TotalCount) {
    return null;
  }

  return <div className="form-poll__poll-result">
    <span>{props.label}</span>
    <>{props.checked ? <span className="form-poll__poll-result-icon icon icon-checkmark"></span> : null}</>
    <span className="ml-auto">{pollScore + "%"}</span>
    <div className="form-poll__poll-result-score" ref={pollScoreBackgroundElement} style={{width: 0}}></div>
  </div>;
};